import { useGetValuation } from 'ClientPortal/src/api/Queries/valuations'
import { throwOnForbiddenApiError } from 'ClientPortal/src/api/react-query-config'
import { useTypedParams } from 'ClientPortal/src/router/useTypedParams'

export function useValuationIncomePage() {
    const { valuationId } = useTypedParams(['valuationId'])
    const { valuation, isValuationPending } = useGetValuation({ valuationId, throwOnError: throwOnForbiddenApiError })

    return {
        valuation,
        isValuationPending,
    }
}
